import { createSlice } from '@reduxjs/toolkit'

export const airportCodeSlice = createSlice({
  name: 'airportCode',
  initialState: {
    value: '',
  },
  reducers: {
    setAirportCode: (state, action) => {
      state.value = action.payload
    }
  },
})

export const { setAirportCode } = airportCodeSlice.actions
export default airportCodeSlice.reducer
